import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import * as fromStore from "../../../../../../store";
import {Store} from "@ngrx/store";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DbValidators} from "../../../../../../shared/validators/DbValidators";
import {DbResponse} from "../../../../../../shared/interceptors/db-response";
import {AuthService} from "../../../../../../auth/auth.service";
import {DbServerErrors} from "../../../../../../shared/interceptors/db-server-errors";
import {CookieService} from "ngx-cookie";
import {filter, first} from "rxjs/operators";

@Component({
    selector: 'db-sign-up-with-hubspot',
    templateUrl: './sign-up-with-hubspot.component.html',
    styleUrls: ['./sign-up-with-hubspot.component.scss'],
    standalone: false
})
export class SignUpWithHubspotComponent implements OnInit {
  @Output() back = new EventEmitter<void>();
  @Output() next = new EventEmitter<string>();
  @Output() close? = new EventEmitter<void>();
  @Input() email: string;
  public hubspotForm: FormGroup;
  public loading: boolean = false;
  public serverErrors: DbServerErrors;

  constructor(
    private _authService: AuthService,
    private _cookieService: CookieService,
    private _store: Store<fromStore.DbStoreState>,
  ) {}

  ngOnInit() {
    this.hubspotForm = new FormGroup({
      'email': new FormControl(this.email, [DbValidators.trim, Validators.required, Validators.email, Validators.pattern(/^[+_\-a-zA-Z0-9]+(\.[+_\-a-zA-Z0-9]+)*@[+_\-a-zA-Z0-9]+(\.[+_\-A-Za-z0-9]+)*(\.[+_\-A-Za-z]{2,24})$/)]),
    });
  }

  public backToPreviousStep(): void {
    this.back.emit();
  }

  public closePopup(): void {
    this.close.emit();
  }

  public checkUserExists(): void {
    if (this.hubspotForm.controls['email'].valid) {
      this.loading = true;
      this._authService.checkUserExists(this.hubspotForm.value.email)
        .pipe(filter((response: DbResponse): boolean => !!response),
        first())
        .subscribe((response) => {
          if (response.success) {
            this._sendHubspotData();
            this.next.emit(this.hubspotForm.value.email);
          }
          else {
            this.loading = false;
            this.serverErrors = response.serverErrors;
          }
        });
    }
  }

  private _sendHubspotData(): void {
    this._authService.sendHubspotData(this.hubspotForm.value.email)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        if (response.data && response.data.tenweb_cookie) {
          this._cookieService.put('FPID', response.data.tenweb_cookie, {path: '/', domain: '10web.io'});
        }
      });
  }

}
